// extracted by mini-css-extract-plugin
export default {"root":"DishesTableTitleLayout_root__RkF+H","placeHolderShimmer":"DishesTableTitleLayout_placeHolderShimmer__M2dEu"};